import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Card } from "react-bootstrap";
import CardHeader from "@material-ui/core/CardHeader";

import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";

import "../css/Product.css";
import { Button } from "@material-ui/core";
import { useStateValue } from "../Stateprovider";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 700,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function Product({ id, title, level, language, price, image, description }) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [{ locked }, dispatch] = useStateValue();

  const addToBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        id: id,
        title: title,
        level: level,
        language: language,
        price: price,
        image: image,
        description: description,
      },
    });
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card
      style={{ maxWidth: "20rem", minWidth: "20rem" }}
      className={"mt-2 mr-1 ml-1 mb-2"}
    >
      <CardHeader
        action={
          <Typography variant="h6" color="textPrimary" component="h2">
            ${price}
          </Typography>
        }
        title={title}
        subheader={language + " - " + level}
      />
      <Card.Img src={image} />
      <Card.Body>
        <Typography variant="body2" color="textSecondary" component="p">
          {description}
        </Typography>
      </Card.Body>
      <Card.Footer>
        {locked.includes(id) ? (
          <Button color="primary" disabled>
            Add to Cart
          </Button>
        ) : (
          <Button
            color="primary"
            startIcon={<AddShoppingCartIcon />}
            onClick={addToBasket}
          >
            Add to Cart
          </Button>
        )}
      </Card.Footer>
    </Card>
  );
}

export default Product;
